import gql from 'graphql-tag'
import { PaymentAccount } from '../../types'

export const EXPORT_VOUCHERS = gql`
  query ExportVouchers($input: ExportInput) {
    export(input: $input) {
      signedLink
      receiptId
    }
  }
`
export const DELETE_VOUCHERS = gql`
  mutation DeleteVoucher($id: String) {
    deleteVoucher(id: $id)
  }
`

export const GET_FINANCIAL_YEARS = gql`
  query GetFinancialYears {
    financialYears {
      id
      year
      start_date
      end_date
    }
  }
`

export const GET_VOUCHERS = gql`
  query getAllVouchers {
    vouchers {
      id
      reference_number
      description
      total_amount
      payment_account
      currency
      invoice_currency
      state
      paid_by_amin
      expense_period
      receivers_account_number
      created_at
      submitted_at
      branch
      pay_to
      department {
        id
        name
      }
      claimed_by {
        id
        first_name
        last_name
      }
      created_by {
        id
        first_name
        last_name
      }
      voucher_approvals {
        approved_at
        status
        comment
        order_number
        approver {
          id
          first_name
          last_name
          email
          branch
          user_role {
            id
            name
            scope
          }
        }
        approval_stage {
          id
          is_payment_stage
        }
      }
      voucher_cost_category {
        cost_share
        comment
        sub_cost_category {
          name
          code
          cost_category {
            name
          }
        }
        receipts {
          id
          path
        }
      }
      comments {
        id
        comment
        created_at
        updated_at
        user {
          id
          first_name
          last_name
        }
      }
      workflow {
        id
      }
      tags {
        id
        name
      }
    }
  }
`

export const GET_MY_VOUCHERS = gql`
  query getMyVouchers {
    myVouchers {
      is_created_by_me
      my_action
      voucher {
        id
        reference_number
        description
        total_amount
        payment_account
        currency
        invoice_currency
        state
        paid_by_amin
        expense_period
        receivers_account_number
        created_at
        submitted_at
        branch
        pay_to
        department {
          id
          name
        }
        claimed_by {
          id
          first_name
          last_name
        }
        created_by {
          id
          first_name
          last_name
        }
        voucher_approvals {
          approved_at
          status
          comment
          order_number
          approver {
            id
            first_name
            last_name
            email
            branch
            user_role {
              id
              name
              scope
            }
          }
          approval_stage {
            id
            is_payment_stage
          }
        }
        voucher_cost_category {
          cost_share
          comment
          sub_cost_category {
            name
            code
            cost_category {
              name
            }
          }
          receipts {
            id
            path
          }
        }
        comments {
          id
          comment
          created_at
          updated_at
          user {
            id
            first_name
            last_name
          }
        }
        workflow {
          id
        }
        tags {
          id
          name
        }
      }
    }
  }
`

export const GET_VOUCHERS_ALL = gql`
  query getAllVouchers($input: Paging) {
    vouchersAll(input: $input) {
      totalCount
      uniquePeriods
      uniqueBranches
      totalAmount
      foreignCurrencyCount
      categoryAmount
      vouchers {
        id
        reference_number
        description
        total_amount
        payment_account
        currency
        invoice_currency
        state
        paid_by_amin
        expense_period
        receivers_account_number
        branch
        created_at
        submitted_at
        department {
          id
          name
        }
        pay_to
        claimed_by {
          id
          first_name
          last_name
        }
        created_by {
          id
          first_name
          last_name
        }
        voucher_approvals {
          id
          approved_at
          status
          comment
          order_number
          approver {
            id
            first_name
            last_name
            email
            branch
            user_role {
              id
              name
              scope
            }
          }
          approval_stage {
            id
            is_payment_stage
          }
        }
        voucher_cost_category {
          cost_share
          comment
          sub_cost_category {
            name
            code
            cost_category {
              name
            }
          }
          receipts {
            id
            path
          }
        }
        comments {
          id
        }
        tags {
          id
          name
        }
        workflow {
          id
          name
        }
      }
    }
  }
`

export const GET_VOUCHER_BY_ID = gql`
  query Voucher($id: String) {
    voucher(id: $id) {
      id
      reference_number
      description
      branch
      paid_by_amin
      payment_reference
      department {
        id
        name
        national_only
      }
      total_amount
      state
      paid_by_amin
      expense_period
      receivers_account_number
      created_at
      submitted_at
      financial_year {
        id
        year
      }
      payment_account
      currency
      invoice_currency
      pay_to
      claimed_by {
        id
        first_name
        last_name
        email
      }
      created_by {
        id
        first_name
        last_name
        email
        branch
        user_role {
          id
        }
      }
      voucher_approvals {
        approved_at
        status
        comment
        order_number
        approver {
          id
          first_name
          last_name
          email
          branch
          user_role {
            id
            name
            scope
          }
        }
        approval_stage {
          id
          is_payment_stage
        }
      }
      voucher_cost_category {
        id
        cost_share
        comment
        sub_cost_category {
          id
          code
          name
          cost_category {
            id
            name
          }
        }
        receipts {
          id
          path
        }
      }
      comments {
        id
        comment
        created_at
        updated_at
        user {
          id
          first_name
          last_name
        }
      }
      workflow {
        id
      }
      tags {
        id
        name
      }
    }
  }
`
export const GET_VOUCHER_COMMENTS = gql`
  query VoucherComments($id: String) {
    voucher(id: $id) {
      id
      comments {
        id
        comment
        created_at
        updated_at
        user {
          id
          first_name
          last_name
        }
      }
    }
  }
`

export const GET_UPLOAD_LINK = gql`
  mutation GetUploadLink($input: SignedLinkInput) {
    getUploadLink(input: $input) {
      signedLink
      receiptId
    }
  }
`

export const GET_DOWNLOAD_LINK = gql`
  query signedDownloadLink($id: String) {
    signedDownloadLink(id: $id) {
      signedLink
    }
  }
`

export const DELETE_RECEIPT = gql`
  mutation DeleteReceipt($id: String) {
    deleteReceipt(id: $id)
  }
`

export const GET_CATEGORIES = gql`
  query allCostCategories {
    costCategories {
      id
      sub_cost_categories {
        id
        name
        code
      }
      name
      code
      is_granular
    }
  }
`

export const GET_DEPARTMENTS = gql`
  query {
    departments {
      id
      name
      national_only
    }
  }
`
export const GET_USERS_LIST = gql`
  query getAllUsers {
    users {
      id
      first_name
      last_name
      branch
      site_admin
      user_role {
        id
        name
        scope
      }
      department {
        id
        name
      }
    }
  }
`

/**
 * This is a utility function takes simple input object and map it into VoucherCreateInput
 * @param input Un mapped voucher input
 */
export const VoucherCreateInputMap = (
  input: VoucherInput,
): VoucherCreateInput => {
  //@ts-ignore
  const mappedInput: VoucherCreateInput = { ...input }

  if (input.department) {
    mappedInput.department = {
      connect: {
        id: input.department,
      },
    }
  }

  if (input.financial_year) {
    mappedInput.financial_year = {
      connect: {
        id: input.financial_year.toString(),
      },
    }
  }

  if (input.created_by) {
    mappedInput.created_by = {
      connect: {
        id: input.created_by,
      },
    }
  }

  if (input.claimed_by) {
    mappedInput.claimed_by = {
      connect: {
        id: input.claimed_by,
      },
    }
  }
  mappedInput.voucher_cost_category = {
    create: input.voucher_cost_category.map((category) => {
      return {
        sub_cost_category: {
          connect: {
            id: category.cost_category.id,
          },
        },
        cost_share: category.cost_share,
      }
    }),
  }
  if (input.workflow) {
    mappedInput.workflow = {
      connect: {
        id: input.workflow,
      },
    }
  }

  return mappedInput
}

export const CREATE_VOUCHER = gql`
  mutation Voucher($input: VoucherCreateInput) {
    createVoucher(input: $input) {
      id
      description
      total_amount
      paid_by_amin
      receivers_account_number

      pay_to

      claimed_by {
        id
        first_name
        last_name
      }

      created_by {
        first_name
        last_name
        id
      }
      voucher_cost_category {
        id
        cost_share
        sub_cost_category {
          id
          name
          code
          cost_category {
            id
            name
          }
        }
      }
    }
  }
`

/**
 * This is a utility function takes simple input object and map it into VoucherUpdateInput
 * @param input Un mapped voucher input
 */
export const VoucherUpdateInputMap = (
  input: VoucherInputUpdate,
): VoucherUpdateInput => {
  //@ts-ignore
  const mappedInput: VoucherUpdateInput = {
    id: input.id,
    description: input.description,
    state: input.state,
    payment_account: input.payment_account,
    currency: input.currency,
    invoice_currency: input.invoice_currency,
    pay_to: input.pay_to,
    submitted_at: input.submitted_at
      ? new Date(
          isNaN(Number(input.submitted_at))
            ? input.submitted_at
            : Number(input.submitted_at),
        ).toISOString()
      : null,
    expense_period: input.expense_period,
  }

  /**
   *  Now we need to retain the cost category ids for receipts so we not do that any more.
   *  cost categories need to created and updated via its own mutation, - Nosherwan
   */
  // mappedInput.voucher_cost_category = {
  //   create: input.voucher_cost_category.map((category) => {
  //     return {
  //       cost_category: {
  //         connect: {
  //           id: category.cost_category.id,
  //         },
  //       },
  //       cost_share: category.cost_share,
  //     }
  //   }),
  // }

  return mappedInput
}

export const UPDATE_VOUCHER = gql`
  mutation Voucher($input: VoucherUpdateInput) {
    updateVoucher(input: $input) {
      id
      reference_number
      description
      branch
      paid_by_amin
      payment_reference
      department {
        id
        name
        national_only
      }
      total_amount
      state
      paid_by_amin
      expense_period
      receivers_account_number
      created_at
      submitted_at
      financial_year {
        id
        year
      }
      payment_account
      currency
      invoice_currency
      pay_to
      claimed_by {
        id
        first_name
        last_name
      }
      created_by {
        id
        first_name
        last_name
        branch
      }
      voucher_approvals {
        approved_at
        status
        comment
        order_number
        approver {
          id
          first_name
          last_name
          email
          branch
          user_role {
            id
            name
            scope
          }
        }
        approval_stage {
          id
          is_payment_stage
        }
      }
      voucher_cost_category {
        id
        cost_share
        comment
        sub_cost_category {
          id
          code
          name
          cost_category {
            id
            name
          }
        }
        receipts {
          id
          path
        }
      }
      comments {
        id
        comment
        created_at
        updated_at
        user {
          id
          first_name
          last_name
        }
      }
      workflow {
        id
      }
      tags {
        id
        name
      }
    }
  }
`

export const CREATE_VOUCHER_COST_CATEGORY = gql`
  mutation CreateVoucherCostCategory($input: CreateVoucherCostCategoryInput) {
    createVoucherCostCategory(input: $input) {
      id
      cost_share
      comment
      sub_cost_category {
        id
        cost_category {
          id
        }
      }
      voucher {
        total_amount
      }
    }
  }
`

export const UPDATE_VOUCHER_COST_CATEGORY = gql`
  mutation UpdateVoucherCostCategory($input: UpdateVoucherCostCategoryInput) {
    updateVoucherCostCategory(input: $input) {
      id
      cost_share
      comment
      voucher {
        total_amount
      }
    }
  }
`

export const DELETE_VOUCHER_COST_CATEGORY = gql`
  mutation DeleteVoucherCostCategory($id: String) {
    deleteVoucherCostCategory(id: $id) {
      id
      voucher {
        total_amount
      }
    }
  }
`

export type VoucherInput = {
  description: string
  department: string
  total_amount: number
  receivers_account_number: string
  created_by?: string
  claimed_by?: string
  pay_to?: string
  financial_year: number
  voucher_cost_category: inputCostCategory[]
  workflow?: number
}

export type VoucherCreateInput = {
  description: string
  // total_amount: number,
  financial_year: Connect
  department: Connect
  receivers_account_number: string
  created_by: Connect
  claimed_by: Connect
  pay_to: string
  voucher_cost_category: {
    create: voucherCostCategory[]
  }
  workflow?: {
    connect: {
      id: number
    }
  }
}

export type VoucherInputUpdate = {
  id: string
  description: string
  state: string
  payment_account: PaymentAccount | null
  currency: string
  invoice_currency: string
  pay_to: string
  submitted_at: string | number | null
  voucher_cost_category: inputCostCategoryUpdate[]
  expense_period?: number | null
}

export type VoucherUpdateInput = {
  id: string
  description: string
  department: Connect
  pay_to: string
  state: string
  financial_year: Connect
  payment_account: PaymentAccount | null
  currency: string
  invoice_currency: string
  submitted_at: string | number | null
  voucher_cost_category: {
    create: voucherCostCategory[]
  }
  expense_period?: number | null
}

export type CreateVoucherCostCategoryInput = {
  voucher_id: string
  sub_cost_category_id: string
  cost_share: number
  comment?: string
}

export type UpdateVoucherCostCategoryInput = {
  id: string
  sub_cost_category_id?: string
  cost_share?: number
  comment?: string
}

type voucherCostCategory = {
  sub_cost_category: Connect
  cost_share: number
}
type Connect = {
  connect: {
    id: string
  }
}
type inputCostCategory = {
  cost_category: { id: string }
  cost_share: number
}
type inputCostCategoryUpdate = {
  sub_cost_category: { id: string }
  cost_share: number
}

export type CommentCreateInput = {
  voucher_id: string
  comment: string
}

export const CREATE_COMMENT = gql`
  mutation CreateComment($input: CommentCreateInput!) {
    createComment(input: $input) {
      id
      comment
      created_at
      updated_at
      user {
        id
        first_name
        last_name
      }
    }
  }
`

export const UPDATE_COMMENT = gql`
  mutation UpdateComment($id: ID!, $input: CommentCreateInput!) {
    updateComment(id: $id, input: $input) {
      id
      comment
      created_at
      updated_at
      user {
        id
        first_name
        last_name
      }
    }
  }
`

export const DELETE_COMMENT = gql`
  mutation DeleteComment($id: ID!) {
    deleteComment(id: $id)
  }
`
